import Mousetrap from "mousetrap";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import $ from "jquery";

import AccountStore from "../stores/AccountStore";

import AccountActions from "../actions/AccountActions";

import AccountingHelper from "../utils/AccountingHelper";

import AccountEdit from "./AccountEdit";

export default class Accounts extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = Accounts.getStoreState();

		// This handles navigating back to the page.
		// There may be a selectedAccount in the store, but a different (or none) id in the query
		// in which case, the account will be selected and re-render the page
		this.state.selectedAccount = null;

		this._onChange = this._onChange.bind(this);
		this.handleAccountNew = this.handleAccountNew.bind(this);
		this.handleAccountSave= this.handleAccountSave.bind(this);
		this.navigateToAccount = this.navigateToAccount.bind(this);
	}

	static getStoreState()
	{
		return {
			accounts: AccountStore.getAccounts(),
			selectedAccount: AccountStore.getSelected(),
		};
	}

	handleAccountNew()
	{
		this.props.history.push("/accounts");
		this.setState({ isNew: true }, async () => {
			await AccountActions.selectAccount(-1);
			$("#accountName").focus();
		});
	}

	async handleAccountSave()
	{
		await this.navigateToAccount(this.state.selectedAccount.kebabName);
	}

	async navigateToAccount(kebabName)
	{
		this.props.history.push(`/accounts/${kebabName}`);
		await AccountActions.selectAccount(this.state.accounts.map(a => a.kebabName).indexOf(kebabName));
	}

	// Method to setState based upon Store changes
	_onChange()
	{
		this.setState(Accounts.getStoreState());
	}

	componentDidUpdate()
	{
		let accountName = this.props.match && this.props.match.params && this.props.match.params.accountName;
		let { selectedAccount, isNew } = this.state;
		if (!selectedAccount && isNew)
		{
			selectedAccount = {};
		}
		const selectedName = selectedAccount ? selectedAccount.kebabName : null;
		if (accountName)
		{
			if (accountName !== selectedName)
			{
				AccountActions.selectAccount(this.state.accounts.map(a => a.kebabName).indexOf(accountName));
			}
		}
		else if (AccountStore.getSelected() !== null)
		{
			// Clear selection
			AccountActions.selectAccount(-1);
		}
	}

	// Add change listeners to stores
	componentDidMount()
	{
		Mousetrap.bind("n", "New Account", this.handleAccountNew, "keyup");
		AccountStore.addChangeListener(this._onChange);

		const selectedAccount = this.props.match && this.props.match.params && this.props.match.params.accountName;
		AccountActions.getAccounts(selectedAccount);
	}

	// Remove change listeners from stores
	componentWillUnmount()
	{
		AccountStore.removeChangeListener(this._onChange);
		Mousetrap.unbind("n", "keyup");
	}

	render()
	{
		let { accounts, selectedAccount, isNew } = this.state;
		if (!selectedAccount && isNew)
		{
			selectedAccount = { type: Enums.accountType.asset };
		}
		const selectedId = selectedAccount ? selectedAccount.id : null;
		const selectedName = selectedAccount ? selectedAccount.kebabName : null;

		return (
			<Row>
				<Col xs={12} md={3}>
					<h1 className="page-header hidden-xs">Accounts</h1>
					<button className="btn btn-primary navbar-btn" onClick={this.handleAccountNew}>New Account</button>
					<Nav bsStyle="pills" stacked activeKey={selectedName} onSelect={this.navigateToAccount}>
						{accounts &&
							accounts.map(account => {
								return (
									<LinkContainer key={account.id} to={`/accounts/${account.kebabName}`}>
										<NavItem eventKey={account.kebabName} disabled={account.id === selectedId}>
											{account.id}: {account.name}
											<span className="label label-info pull-right">{AccountingHelper.formatMoney(account.amount, account.currencyId)}</span>
											{account.hideIfEmpty && <span className="label label-warning pull-right">inactive</span>}
										</NavItem>
									</LinkContainer>
								);
							})
						}
					</Nav>
				</Col>
				<Col xs={12} md={9}>
					{selectedAccount &&
						<AccountEdit
							account={selectedAccount}
							onAccountSave={this.handleAccountSave}
						/>
					}
				</Col>
			</Row>
		);
	}
}

Accounts.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func
	}),
	match: PropTypes.object
};



// WEBPACK FOOTER //
// ./Components/components/Accounts.jsx